import React from 'react';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Select from "../../components/form/Select";
import DAYS from './../../data/Days';
import ONDE_TREINA from './../../data/Onde_treina';
import TEMPO_MUSCULACAO from './../../data/TempoMusculacao';
import TIPOS_PLANILHA from './../../data/TiposPlanilha';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Modal from '../../components/modal/Modal';
import Objetivo from './Objetivo';
const URL_LOAD = WS.treino.load;
const URL_UPDATE = WS.treino.update;

export default class PageTreino extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      strings: STRINGS[window.LANGUAGE],
      statusOt: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.openObjetivo = this.openObjetivo.bind(this);
  }

  getItemSelect(__args__) {
    const check = __args__.value;
    let resp;
    const arr = __args__.arr;

    arr.map((value,i)=>{
      if(value.value === check){
        resp = arr[i];
        return false;
      }
    });
    return resp;
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    Requisitions({
      url: URL_LOAD,
      data:{},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            ...data.data,
            loaded: true,
            statusOt: data.data.onde_treina === 'casa' ? true : false
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });
  }

  handleSelect(__args__){
    let statusOt = (__args__.name === 'onde_treina' && __args__.value === 'casa');

    if(statusOt){
      const {
        atencao,
        treinoCasaTxt
      }
      = this.state.strings;
      Dialog.create({
        title: atencao,
        text: treinoCasaTxt
      });
    }

    //previne que o select de O que procura?* apareça ao usar outro select
    if(this.state.statusOt && !statusOt && __args__.name !== 'onde_treina' ){
      statusOt = true;
    }

    this.setState({[__args__.name]:__args__.value, statusOt});
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const data = {...this.state};

    var self = this;
    const {
      atencao,
      salvoSucesso,
      preenchaCamposAsterisco,
      erroSalvar
    }
    = this.state.strings;

    if(!data.tipo_treino ||
      !data.onde_treina ||
      !data.qtd_dias ||
      !data.tempo_musculacao){
      var msg = {
        title: atencao,
        text: preenchaCamposAsterisco
      };

      Dialog.create(msg);
      return false;
    }else{

      Requisitions({
        url:URL_UPDATE,
        data: data,
        sucess:function(data){
          var msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        },
        error:function(data){
          Dialog.create({
            title: atencao,
            text: erroSalvar
          });
        }
      });
    }
  }

  openObjetivo(e) {
    var modal = new Modal();
    modal.open({page:<Objetivo modal={modal} />});

    e.preventDefault();
  }

  render(){
    const strings = this.state.strings;

    //-----
    const tipo_treino = this.getItemSelect({
      value: this.state.tipo_treino,
      arr: TIPOS_PLANILHA});

    const onde_treina = this.getItemSelect({
      value: this.state.onde_treina,
      arr: ONDE_TREINA});

    const qtd_dias = this.getItemSelect({
      value: this.state.qtd_dias,
      arr: DAYS});

    const tempo_musculacao = this.getItemSelect({
      value: this.state.tempo_musculacao,
      arr: TEMPO_MUSCULACAO});
    //------

    const statusOt = !this.state.statusOt ? (
      <div>
        <Select
          isSearchable={false}
          key={Math.random()}
          name='tipo_treino'
          onChange={(e)=>this.handleSelect({name: 'tipo_treino', value: e.value})}
          title={`${strings.txtTipoTreino}*`}
          options={TIPOS_PLANILHA}
          value={tipo_treino}
        />
      <a href='#' onClick={this.openObjetivo} className='btObjetivo'>{strings.btObjetivo}</a>
      </div>
    ) : null;

    return(
      <div>
        <form className="form-login"  onSubmit={this.handleSubmit}>
          <Select
            isSearchable={false}
            key={Math.random()}
            name='onde_treina'
            onChange={(e)=>this.handleSelect({name: 'onde_treina', value: e.value})}
            title={`${strings.txtOndeTreina}*`}
            options={ONDE_TREINA}
            value={onde_treina}
          />
          {statusOt}
          <Select
            isSearchable={false}
            key={Math.random()}
            name='qtd_dias'
            onChange={(e)=>this.handleSelect({name: 'qtd_dias', value: e.value})}
            title={`${strings.txtQuantidadeDias}*`}
            options={DAYS}
            value={qtd_dias}
          />
          <Select
            isSearchable={false}
            key={Math.random()}
            name='tempo_musculacao'
            onChange={(e)=>this.handleSelect({name: 'tempo_musculacao',value: e.value})}
            title={`${strings.txtTempoMusculacao}*`}
            options={TEMPO_MUSCULACAO}
            value={tempo_musculacao}
          />
          <Button
            text={strings.txtSalvar}
            onClick={this.handleSubmit}
            type='submit'
            classes="button-login simple-button"
          />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/perfil/PageTreino.js